import { type OpenApiLinkDeliveryServiceType, type OpenApiSchemaDeliveryWarehouseSettings } from '#shared/api/schema';
import { DELIVERY_SERVICES_MAPPING } from '#shared/lib/constants';

export const getWarehouseDeliveryServices = (warehouseSettings: OpenApiSchemaDeliveryWarehouseSettings) => {
    const services: Array<OpenApiLinkDeliveryServiceType> = [];

    if (warehouseSettings.yandex.enabled) {
        services.push(DELIVERY_SERVICES_MAPPING.YANDEX_DELIVERY);
    }

    if (warehouseSettings.cdek.enabled) {
        services.push(DELIVERY_SERVICES_MAPPING.CDEK);
    }

    if (warehouseSettings.meta_ship_russian_post.enabled) {
        services.push(DELIVERY_SERVICES_MAPPING.META_SHIP_RUSSIAN_POST);
    }

    if (warehouseSettings.meta_ship_dalli.enabled) {
        services.push(DELIVERY_SERVICES_MAPPING.META_SHIP_DALLI);
    }

    if (warehouseSettings.meta_ship_pecom.enabled) {
        services.push(DELIVERY_SERVICES_MAPPING.META_SHIP_PECOM);
    }

    if (warehouseSettings.ycp_delivery.enabled) {
        services.push(DELIVERY_SERVICES_MAPPING.YCP_DELIVERY);
    }

    return services;
};
